import dayjs from 'dayjs';

import { Text, Tooltip } from '@/design-system';
import { toRelativeTime } from '@/utils/to-relative-time';

export default function RelativeTime({
  utcTime,
  shortFormat,
}: {
  utcTime: string;
  shortFormat?: boolean;
}) {
  const relativeTime = toRelativeTime(utcTime, shortFormat);
  const localTime = dayjs(utcTime).local();
  const title = localTime.format('M/D/YYYY h:mm:ss A');
  return (
    <Tooltip title={title}>
      <Text variant="sm">{relativeTime}</Text>
    </Tooltip>
  );
}
